import { render } from "./Greet.vue?vue&type=template&id=409eb9d6&scoped=true"
import script from "./Greet.vue?vue&type=script&lang=js"
export * from "./Greet.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-409eb9d6"

export default script